import React, { createContext, useContext, useState, useEffect } from 'react'
import Service from '../service'

const FlowManagerContext = createContext();

const FlowManagerContextProvider = ({ children }) => {
  const [selectedResponse, setSelectedResponse] = useState({})
  const [selectedSubscription, setSelectedSubscription] = useState({})
  const [selectedPurchase, setSelectedPurchase] = useState({})
  const [customFormId, setCustomFormId] = useState('')
  const [selectedFlowStageId, setSelectedFlowStageId] = useState('')
  const [prevStageResult, setPrevStageResult] = useState({})
  const [formData, setFormData] = useState({})

  return (
    <FlowManagerContext.Provider value ={{
      selectedResponse, setSelectedResponse,
      customFormId, setCustomFormId,
      selectedFlowStageId, setSelectedFlowStageId,
      prevStageResult, setPrevStageResult,
      formData, setFormData,
      selectedSubscription, setSelectedSubscription,
      selectedPurchase, setSelectedPurchase
    }}>
      {children}
    </FlowManagerContext.Provider>
  )
}

const useFlowManager = () => useContext(FlowManagerContext)

export { useFlowManager }
export default FlowManagerContextProvider;